/* eslint-disable global-require */
import angular from 'angular';
import CommentController from './comment.controller';

import './comment.style.scss';

const CommentTemplate = /* html */ `
  <ab-card
    classes="filled"
    title-user="{{ $ctrl.comment.author_id }}"
    subtitle="{{ $ctrl.subtitle }}"
    main-text="{{ $ctrl.comment.content }}"
    title-action="$ctrl.deleteComment($ctrl.comment.id)"
    title-action-icon="btn-delete"
  ></ab-card>
`;

export const CommentComponent = {
  selector: 'comment',
  bindings: {
    comment: '<',
  },
  controller: CommentController,
  transclude: true,
  template: CommentTemplate,
};

export default angular.module('directives.comment', [])
  .component(CommentComponent.selector, CommentComponent)
  .name;
